import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { DropdownMenuItem } from 'v5/design-system/DropdownMenu';
import { Send } from 'lucide-react';
import { useSendBookingConfirmation } from 'v5/features/productions/resourcing/hooks/useSendBookingConfirmation';

const BookingConfirmationMenuItem = ({ bookingId }) => {
  const { t } = useTranslation('productions');
  const send = useSendBookingConfirmation(bookingId);

  return (
    <DropdownMenuItem onSelect={() => send?.run()}>
      <Send />
      {t('resourcingRowContextSendBooking')}
    </DropdownMenuItem>
  );
};

BookingConfirmationMenuItem.propTypes = {
  bookingId: PropTypes.number.isRequired
};

export default BookingConfirmationMenuItem;
